import Vue from 'vue'
import Vuex from 'vuex'
import NewsList from './modules/newsList.js'
import New from './modules/new.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loadStatus: false,
        newType: 1,
        newCategory: '',
        newId: 0
    },
    mutations: {
        showLoading(state) {
            state.loadStatus = true;
        },
        closeLoading(state) {
            state.loadStatus = false;
        },
        changeNewType(state, payload) {
            state.newType = payload.type;
        },
        changeNewCategory(state, payload) {
            state.newCategory = payload.category;
        },
        changeNewId(state, payload) {
            state.newId = payload.id;
        }
    },
    actions: {
        showLoading({
            commit
        }) {
            commit('showLoading');
        },
        closeLoading({
            commit
        }) {
            commit('closeLoading');
        },
        changeNewType({
            commit
        }, payload) {
            commit('changeNewType', payload);
        },
        changeNewCategory({
            commit
        }, payload) {
            commit('changeNewCategory', payload);
        },
        changeNewId({
            commit
        }, payload) {
            commit('changeNewId', payload);
        }
    },
    modules: {
        NewsList,
        New
    }
});